import type { Creative } from '../types'

/**
 * Identity used to group a post's platform siblings: one post can fan out to
 * several platform creatives under a single `projectId`, so that's the key;
 * legacy single-platform posts fall back to the creative id. Used to scope
 * per-post UI state like the composer's shared video mute (see PreviewVideo).
 */
export function postKeyForCreative(creative: Pick<Creative, 'projectId' | 'id'>): string {
  return creative.projectId ?? creative.id
}
